export default __webpack_public_path__ + "static/media/TropicalGarden.b6d6042e.otf";